"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConceptOfferHintHandlers = void 0;
var _react = require("react");
var _types = require("../types");
const useConceptOfferHintHandlers = ({
  addOfferHandler,
  offerType,
  selectedBenefits,
  selectedItems1stSection,
  setSelectedQuantity
}) => {
  const handleAddConceptOffer = (0, _react.useCallback)(async () => {
    const finalSelectedItemData = ({
      itemCode,
      purchasedQuantity,
      selectedQuantity
    }) => ({
      itemCode,
      // only quantity difference will be added to the amounts already in basket
      selectedQuantity: selectedQuantity - purchasedQuantity
    });
    const selectedItemsToAdd = selectedItems1stSection.map(finalSelectedItemData).filter(({
      selectedQuantity
    }) => selectedQuantity > 0);
    const selectedBenefitsToAdd = selectedBenefits.map(finalSelectedItemData).filter(({
      selectedQuantity
    }) => selectedQuantity > 0);

    // looks like benefits don't have to be added here, will be added automatically
    // (except of benefits for choose & choose)
    const finalSelectedItems = offerType === _types.BasketOfferTypes.CHOOSE_AND_CHOOSE ? [...selectedItemsToAdd, ...selectedBenefitsToAdd] : selectedItemsToAdd;
    await addOfferHandler(finalSelectedItems);
  }, [addOfferHandler, offerType, selectedBenefits, selectedItems1stSection]);
  const handleToggleItem = (0, _react.useCallback)((itemCode, shouldSelect, isBenefit = false) => setSelectedQuantity(itemCode, shouldSelect ? 1 : 0, isBenefit), [setSelectedQuantity]);
  return {
    handleAddConceptOffer,
    handleChangeItemQuantity: setSelectedQuantity,
    handleToggleItem
  };
};
exports.useConceptOfferHintHandlers = useConceptOfferHintHandlers;